var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "ds-legend", attrs: { title: _vm.tooltip } },
    [
      _vm.pct
        ? _c("span", { staticClass: "ds-legend__pct" }, [
            _vm._v(_vm._s(_vm.pct)),
          ])
        : _vm._e(),
      _vm.delta !== null
        ? _c(
            "span",
            { staticClass: "ds-legend__delta", class: _vm.deltaClass },
            [
              _c("ds-icon", { attrs: { name: _vm.deltaIcon, size: 15 } }),
              _vm._v(
                " " + _vm._s(Math.abs(_vm.delta).toLocaleString("pt-BR")) + " "
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }